export const ROUTES = {
  ROOT: '/',
  ABOUT: '/about',
  HOME: '/home',
  PLANS: '/plans',
  DAILY_LOGS: '/daily-logs',
  REPORTS: '/reports',
  REPORT_NEW: '/reports/new',
  MY_PAGE: '/my-page',
  MY_PAGE_PRIVACY: '/my-page/privacy',
  ROUTINE_GOALS: '/routine-goals',
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  SIGN_UP_EMAIL_VERIFICATION: '/sign-up/email-verification',
  SIGN_UP_DETAILS: '/sign-up/details',
  PASSWORD_RESET: '/password-reset',
  PASSWORD_RESET_EMAIL_VERIFICATION: '/password-reset/email-verification',
  POLICY_CONSENT: '/policy-consent',
  TERMS_OF_SERVICE: '/terms-of-service',
  TERMS_OF_SERVICE_HISTORY: '/terms-of-service/history',
  OPEN_SOURCE_LICENSES: '/open-source-licenses',
  PRIVACY_POLICY: '/privacy-policy',
  PRIVACY_POLICY_HISTORY: '/privacy-policy/history',
}

export const getWeeklyPlanPath = (sessionalPlanId) => `${ROUTES.PLANS}/${sessionalPlanId}/weeks`
export const getReportDetailPath = (reportId) => `${ROUTES.REPORTS}/${reportId}`
export const getReportEditPath = (reportId) => `${getReportDetailPath(reportId)}/edit`
export const getPrivacyPolicyDocumentPath = legalDocumentId => (
  `${ROUTES.PRIVACY_POLICY_HISTORY}/${legalDocumentId}`
)
export const getTermsOfServiceDocumentPath = legalDocumentId => (
  `${ROUTES.TERMS_OF_SERVICE_HISTORY}/${legalDocumentId}`
)
